import React, { useState } from 'react'
import {
  GridColumn as Column,
  Grid,
  GridCellProps,
  GridPageChangeEvent,
} from '@progress/kendo-react-grid'
import {
  TransactionAdjustmentUploadHistory,
  TransactionAdjustmentUploadHistoryKey,
} from 'api/Wallet/Types/TransactionAdjustmentUploadHistory'
import { GridFilterState, initialState } from 'store/grid'
import { pageableSettings } from 'store/grid/grid.slice'

interface Props {
  data: TransactionAdjustmentUploadHistory
}
export const UploadTransactionHistoryTable: React.FC<Props> = ({ data }) => {
  const [paginationState, setPaginationState] = useState<GridFilterState>({ ...initialState() })
  const handlePageChange = (event: GridPageChangeEvent) => {
    if (data && data.details.length > 0) {
      setPaginationState({ ...initialState(), skip: event.page.skip, take: event.page.take })
    }
  }

  return (
    <Grid
      resizable
      data={data?.details.slice(paginationState.skip, paginationState.take + paginationState.skip)}
      skip={paginationState.skip}
      take={paginationState.take}
      total={data?.details.length}
      onPageChange={handlePageChange}
      pageable={pageableSettings}
      style={{ zIndex: 0, margin: '2.5em 0 2.5rem 0' }}
    >
      <Column
        field={TransactionAdjustmentUploadHistoryKey.lineNumber}
        title='Line'
        width={50}
        minResizableWidth={50}
      />
      <Column
        field={TransactionAdjustmentUploadHistoryKey.record}
        title='CSV Amount'
        width={100}
        minResizableWidth={100}
      />
      <Column
        title='Deducted Amount'
        width={130}
        minResizableWidth={130}
        cell={(gridCellProps: GridCellProps) => {
          let realAmount = '-'
          if (!gridCellProps.dataItem?.masterTransaction) return <td>{realAmount}</td>
          const { debitAmount, creditAmount } = gridCellProps.dataItem.masterTransaction
          if (gridCellProps.dataItem?.directionType?.name === 'Debit') realAmount = debitAmount
          else realAmount = creditAmount
          return <td>{realAmount}</td>
        }}
      />
      <Column
        field={TransactionAdjustmentUploadHistoryKey.directionType}
        title='Direction'
        width={75}
        minResizableWidth={75}
      />
      <Column
        field={TransactionAdjustmentUploadHistoryKey.tradingAccount}
        title='Trading Account'
        width={125}
        minResizableWidth={125}
      />
      <Column
        field={TransactionAdjustmentUploadHistoryKey.transaction}
        title='Transaction'
        width={150}
        minResizableWidth={150}
      />
      <Column
        field={TransactionAdjustmentUploadHistoryKey.status}
        title='Status'
        width={140}
        minResizableWidth={140}
      />
      <Column
        field={TransactionAdjustmentUploadHistoryKey.result}
        title='Result'
        width={170}
        minResizableWidth={170}
      />
    </Grid>
  )
}
